import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Report, AppliedReportOptions } from '../models/report.model';
import { ApiService } from './api.service';
import { PagedResults } from '../models/paged-results/paged-results.model';
import { LimitOffsetPagingMeta, Paging } from '../models/paged-results/limit-offset-paging.model';

export class PagedReports implements PagedResults {
  reports: Report[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.reports;
  }
}

@Injectable()
export class ReportsService extends ApiService {
  private http = inject(HttpClient);


  create(reportsUrl: string, filters: AppliedReportOptions, outputOptions: AppliedReportOptions): Observable<Report> {
    return this.http.post<Report>(reportsUrl, { filters, outputOptions });
  }

  get(reportsUrl: string, id): Observable<Report> {
    return this.http.get<Report>(`${reportsUrl}/${id}`);
  }

  cancel(reportsUrl: string, id): Observable<Report> {
    return this.http.patch<Report>(`${reportsUrl}/${id}/cancel`, {});
  }

  getList(reportsUrl: string, paging: Paging = null): Observable<PagedReports> {
    const params = new URLSearchParams();

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedReports>(`${reportsUrl}?${params.toString()}`);
  }
}
